import HomeCard from "../../components/HomeCard/HomeCard";
import { useNavigate } from "react-router-dom";
import styles from "./Home.module.scss";
import account from "../../assets/icons/account.png";
import devices from "../../assets/icons/devices.svg";
import support from "../../assets/icons/support.svg";
import knowledge from "../../assets/icons/knowledge.svg";
import invoices from "../../assets/icons/invoices.svg";
import { useTranslation } from "react-i18next";
import { useEffect } from "react";
import { trackEvent } from "../../utils/analytics";
import { EVENT_NAMES } from "../../types/event-names";
import { useActiveTrialEventMutation } from "../../store/services/details-api";
import { useAppSelector } from "../../store/hooks";

const headerCardData = [
  {
    title: "My Account",
    subtitle: "Manage your personal information, preferences, and subscriptions.",
    icon: account,
    path: "/account",
  },
  {
    title: "Devices",
    subtitle: "View protected devices, download apps and remove devices.",
    icon: devices,
    path: "/devices",
  },
  {
    title: "Invoices",
    subtitle: "Access your billing history & download invoices",
    icon: invoices,
    path: "/invoices",
  },
  {
    title: "Support",
    subtitle: "Submit a support ticket for any unanswered question or request.",
    icon: support,
    path: "https://www.fortect.com/support/",
    target: "_blank",
  },
  {
    title: "Knowledge Base",
    subtitle: "View our articles for detailed information on our products and services.",
    icon: knowledge,
    path: "https://www.fortect.com/support/knowledge/",
    target: "_blank",
  },
];

function HomePage() {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [activeTrialEvent] = useActiveTrialEventMutation();
  const user = useAppSelector((state) => state.auth.user);
  // const user = useSelector(selectUser);

  const handleCardClick = (path: string, target: string | null) => {
    if (path.startsWith("http")) {
      if (target) {
        window.open(path, target);
      } else {
        window.location.href = path;
      }
    } else {
      navigate(path);
    }
  };

  useEffect(() => {
    trackEvent(EVENT_NAMES.SCREEN_DASHBOARD_VIEWED, { screen_name: "Home" });

    if (sessionStorage.firstLogin && user?.email) {
      trackEvent(EVENT_NAMES.FIRST_LOGIN_DASHBOARD);
      sessionStorage.removeItem("firstLogin");
      activeTrialEvent({ email: user.email, activeTrailData: { Ext25: "active", ext25: "active" } });
    }
  }, [user?.email, activeTrialEvent]);

  return (
    <div className={styles.root}>
      <div className={styles.root_header}>
        <h1 className={styles.root_title}>{t("Welcome")}!</h1>
        <h2 className={styles.root_subtitle}>
          {t("Simplify your Fortect experience with centralized account management.")}
        </h2>
      </div>
      <div className={styles.root_main}>
        {headerCardData.map((card, index) => (
          <div key={index} className={styles.card}>
            <HomeCard
              onClick={() => {
                handleCardClick(card.path, card.target ?? null);
              }}
              title={card.title}
              subtitle={card.subtitle}
              icon={card.icon}
            />
          </div>
        ))}
      </div>
    </div>
  );
}

export default HomePage;
